import {
  buildProjectUrlPath,
  type ProjectDetailsTabPath,
} from "@repo/app-types/helpers/adminAppRoutes";
import { useNavigate } from "react-router";

export const useProjectNavigation = (projectId: string) => {
  const navigate = useNavigate();

  const navigateToTab = (tabPath: ProjectDetailsTabPath) => {
    navigate(buildProjectUrlPath(projectId, tabPath));
  };

  return { navigateToTab };
};
